<template>
  <div class="view" :style="{ height: fixedHeight + 'px' }">
    <div class="viewLeft">
      <!-- 搜索框 -->
      <div class="searchView">
        <el-input
          placeholder="芯片号/脖圈号/宠物名称"
          v-model="search"
          clearable
          prefix-icon="el-icon-search"
          class="search"
        >
        </el-input>
        <el-button type="primary" @click="handelSearchClick">搜索</el-button>
      </div>

      <!-- 搜索信息 -->
      <div class="msg">
        <div class="msgIcon">
          <div class="msgName">
            姓名：
            <span v-if="pet == null">--</span>
            <el-tooltip
              class="item"
              effect="dark"
              :content="pet.insideName"
              placement="right"
              v-else
            >
              <span>{{ pet.insideName }}</span>
            </el-tooltip>
          </div>
          <img
            src="../../assets/img/ht1.png"
            v-if="pet != null && pet.petSex == '公'"
          />
          <img
            src="../../assets/img/ht2.png"
            v-if="pet != null && pet.petSex == '母'"
          />
        </div>
        <div class="msgApply">
          <div>种类：{{ pet == null ? "--" : pet.applyType.title }}</div>
          <div>品种：{{ pet == null ? "--" : pet.breedInfo.name }}</div>
        </div>

        <div class="msgCom">年龄：{{ pet == null ? "--" : pet.age }}</div>
        <div class="msgCom">
          <span>特征：</span>
          <span v-if="pet == null">--</span>
          <span v-if="pet != null && pet.customFeatures.length == 0">--</span>
          <template v-if="pet != null && pet.customFeatures.length != 0">
            <span
              v-for="(item, index) in pet.customFeatures"
              :key="index"
              style="margin-right: 2px"
              >{{ item }}</span
            >
          </template>
        </div>
        <div class="msgCom">
          价格：{{ pet == null ? "--" : pet.sale_price }}
        </div>
        <div class="msgCom">芯片：{{ pet == null ? "--" : pet.epromNo }}</div>
        <div class="msgCom">
          脖圈号：{{ pet == null ? "--" : pet.insideNo }}
        </div>
        <div class="msgCom">
          疫苗：{{ pet == null ? "--" : "第" + pet.vaccineNeedle + "针" }}
        </div>
        <div class="msgCom">
          状态：{{ pet == null ? "--" : pet.status.title }}
        </div>
        <div class="msgCom">
          门店：{{ pet == null ? "--" : pet.feedShop.name }}
        </div>
      </div>
      <!-- 库存 -->
      <div class="stock" v-if="summary != null">
        <div class="stockName">猫 当前库存</div>
        <div class="stockMsg">
          <div class="stockCom">
            <div>
              {{
                summary.stockInfo.length == 0
                  ? "0"
                  : summary.stockInfo[0].maleCount +
                    summary.stockInfo[0].femaleCount
              }}(只)
            </div>
            <div>总数量</div>
          </div>
          <div class="stockCom">
            <div>
              {{
                summary.stockInfo.length == 0
                  ? "0"
                  : summary.stockInfo[0].maleCount
              }}(只)
            </div>
            <div>公</div>
          </div>
          <div class="stockCom">
            <div>
              {{
                summary.stockInfo.length == 0
                  ? "0"
                  : summary.stockInfo[0].femaleCount
              }}(只)
            </div>
            <div>母</div>
          </div>
        </div>
        <div class="line"></div>
        <div class="stockName">狗 当前库存</div>
        <div class="stockMsg">
          <div class="stockCom">
            <div>
              {{
                summary.stockInfo.length == 0
                  ? "0"
                  : summary.stockInfo[1].maleCount +
                    summary.stockInfo[1].femaleCount
              }}(只)
            </div>
            <div>总数量</div>
          </div>
          <div class="stockCom">
            <div>
              {{
                summary.stockInfo.length == 0
                  ? "0"
                  : summary.stockInfo[1].maleCount
              }}(只)
            </div>
            <div>公</div>
          </div>
          <div class="stockCom">
            <div>
              {{
                summary.stockInfo.length == 0
                  ? "0"
                  : summary.stockInfo[1].femaleCount
              }}(只)
            </div>
            <div>母</div>
          </div>
        </div>
      </div>
      <!-- 销售表 -->
      <div class="rota">
        <div class="rotaName">活体销售</div>
        <el-date-picker
          v-model="rotaDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          style="width: 220px"
          @change="getSaleSummaryData"
        
        >
        </el-date-picker>
        <div class="allNum" v-if="dogSummary != null && catSummary != null">
          <div>总数：</div>
          <div>
            {{ dogSummary.count + catSummary.count }}只 (¥{{
              Math.round((dogSummary.amount + catSummary.amount) * 100) / 100
            }})
          </div>
        </div>
        <div class="comNum" v-if="dogSummary != null && catSummary != null">
          <div style="background: #ff9d3e">狗</div>
          <div>{{ dogSummary.count }}只 (¥{{ dogSummary.amount }})</div>
        </div>
        <div class="comNum" v-if="dogSummary != null && catSummary != null">
          <div style="background: #3d7ef8">猫</div>
          <div>{{ catSummary.count }}只 (¥{{ catSummary.amount }})</div>
        </div>
        <div class="biao">
          <div class="biaoL">
            <div id="pie0" style="height: 100px; width: 100px"></div>
            <div style="margin-top: 8px">销量</div>
          </div>
          <div class="biaoR">
            <div id="pie1" style="height: 100px; width: 100px"></div>
            <div style="margin-top: 8px">价格</div>
          </div>
        </div>
      </div>
    </div>
    <div class="viewRight">
      <!-- 功能按钮 -->
      <div class="tabView">
        <div :class="tab == 4 ? 'tabComS' : 'tabCom'" @click="tab = 4">
          <img src="../../assets/img/ht10.png" v-if="tab != 4" />
          <img src="../../assets/img/ht10S.png" v-else />
          <div>宠物列表</div>
        </div>
        <div :class="tab == 2 ? 'tabComS' : 'tabCom'" @click="tab = 2">
          <img src="../../assets/img/ht8.png" v-if="tab != 2" />
          <img src="../../assets/img/ht8S.png" v-else />
          <div>转移列表</div>
        </div>
        <div :class="tab == 3 ? 'tabComS' : 'tabCom'" @click="tab = 3">
          <img src="../../assets/img/ht9.png" v-if="tab != 3" />
          <img src="../../assets/img/ht9S.png" v-else />
          <div>操作日志</div>
        </div>

        <div class="tabR" v-if="summary != null">
          <div :class="tab == 5 ? 'tabItemS' : 'tabItem'" @click="tab = 5">
            <div class="tabItemT">{{ summary.waitReceiveCount }}</div>
            <div class="tabIcon">
              <div>待接收宠物</div>
              <img src="../../assets/img/htRight.png" v-if="tab != 5" />
            </div>
          </div>
          <div :class="tab == 6 ? 'tabItemS' : 'tabItem'" @click="tab = 6">
            <div class="tabItemT">{{ summary.transferringCount }}</div>
            <div class="tabIcon">
              <div>转移中宠物</div>
              <img src="../../assets/img/htRight.png" v-if="tab != 6" />
            </div>
          </div>
          <div :class="tab == 7 ? 'tabItemS' : 'tabItem'" @click="tab = 7">
            <div class="tabItemT">{{ summary.waitTakeCount }}</div>
            <div class="tabIcon">
              <div>交付列表</div>
              <img src="../../assets/img/htRight.png" v-if="tab != 7" />
            </div>
          </div>
          <div :class="tab == 8 ? 'tabItemS' : 'tabItem'" @click="tab = 8">
            <div class="tabItemT">{{ summary.deathCount }}</div>
            <div class="tabIcon">
              <div>已亡故宠物</div>
              <img src="../../assets/img/htRight.png" v-if="tab != 8" />
            </div>
          </div>
        </div>
      </div>

      <panelPets v-if="tab == 4" :shopType="1"></panelPets>
      <panelTrans
        v-if="tab == 2"
        @refresh="getSummaryData"
        :shopType="1"
      ></panelTrans>
      <panelLog v-if="tab == 3" :shopType="1"></panelLog>
      <panelWaitReceive
        v-if="tab == 5"
        @refresh="getSummaryData"
        :shopType="1"
      ></panelWaitReceive>
      <panelTransing
        v-if="tab == 6"
        @refresh="getSummaryData"
        :shopType="1"
      ></panelTransing>
      <panelTake v-if="tab == 7" :shopType="1"></panelTake>
      <panelWanggu v-if="tab == 8" :shopType="1"></panelWanggu>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import { summary, saleSummary, keyword, deletepet } from "@/api/purchaseApi.js";
import panelTrans from "./panel/panel_trans.vue";
import panelLog from "./panel/panel_log.vue";
import panelPets from "./panel/panel_pets.vue";
import panelWaitReceive from "./panel/panel_waitReceive.vue";
import panelTransing from "./panel/panel_transing.vue";
import panelTake from "./panel/panel_waitTake.vue";
import panelWanggu from "./panel/panel_wanggu.vue";
export default {
  components: {
    panelTrans,
    panelLog,
    panelPets,
    panelWaitReceive,
    panelTransing,
    panelTake,
    panelWanggu,
  },
  data() {
    return {
      fixedHeight: "", //模型高度
      search: "", //搜索
      sex: 0, //0空 1公 2母
      rotaDate: "", //销售时间筛选
      myChart0: null,
      myChart1: null,
      summary: null, //汇总数据
      dogSummary: null, //狗销售数据
      catSummary: null, //猫销售数据
      pet: null, //宠物信息
      tab: 4, //tab切换 默认为1 活体库存
      addType: 0, //0新增 1是更新
      isAddPet: false, //是否显示新增宠物页面
    };
  },
  created() {
    this.fixedHeight = document.documentElement.clientHeight - 106;
  },
  mounted() {
    this.getSaleSummaryData();
    this.myChart0 = echarts.init(document.getElementById("pie0"));
    this.myChart1 = echarts.init(document.getElementById("pie1"));
    this.getSummaryData();
  },
  methods: {
   formatChu (a) {
      if (a < 12) {
        return a + "个月";
      }
      if (a == 12) {
        return "1岁";
      } else {
        var n1 = Math.floor(a / 12);
        var n2 = a % 12;
        console.log(a, n1, n2);
        return n1 + "岁" + n2 + "个月";
      }
    },
    //删除宠物
    handelDeleteClick() {
      this.$confirm("是否删除该宠物？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: this.pet._id,
          };
          deletepet(params).then((res) => {
            if (res.code == 0) {
              console.log(res);
              this.$message({
                type: "success",
                message: "已删除",
              });
              this.handelSearchClick();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //获取当前月天数
    mGetDate(year, month) {
      var day = new Date(year, month, 0);
      return day.getDate();
    },
    //获取宠物销售数据汇总
    getSaleSummaryData() {
      let that = this;
      let params;
      if (this.rotaDate == "") {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        // console.log(year, month, this.mGetDate(year, month))
        let initStart = new Date(`${year}-${month}-01`).getTime() / 1000;
        let initEnd =
          new Date(`${year}-${month}-${this.mGetDate(year, month)}`).getTime() /
          1000;
        // console.log(initStart, initEnd)
        this.rotaDate = [
          new Date(`${year}-${month}-01`),
          new Date(`${year}-${month}-${this.mGetDate(year, month)}`),
        ];
        params = {
          startTime: initStart,
          endTime: initEnd,
          shopId: this.$store.state.shopId,
        };
      } else {
        params = {
          startTime: new Date(this.rotaDate[0]).getTime() / 1000,
          endTime: new Date(this.rotaDate[1]).getTime() / 1000,
          shopId: this.$store.state.shopId,
        };
      }
      saleSummary(params).then((res) => {
        // console.log(res)
        if (res.code == 0) {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].petType == "1") {
              that.catSummary = res.data[i];
            } else if (res.data[i].petType == "2") {
              that.dogSummary = res.data[i];
            }
            if (that.catSummary != null && that.dogSummary != null) {
              that.draw0();
              that.draw1();
            }
          }
        }
      });
      // console.log(that.rotaDate)
    },
    //获取宠物汇总
    getSummaryData() {
      let that = this;
      console.log(this.$store.state.shopId);
      let params = {
        shopId: this.$store.state.shopId,
      };

      summary(params).then((res) => {
        if (res.code == 0) {
          console.log("汇总", res.data);
          that.summary = res.data;
        }
      });
    },
    //搜索数据
    handelSearchClick() {
      let that = this;
      let params = {
        keyword: this.search,
      };
      keyword(params).then((res) => {
        if (res.code == 0) {
          console.log("搜索信息", res);
          that.pet = res.data;
        }
      });
    },
    //价格表
    draw1() {
      let that = this;
      this.myChart1.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
          position: ["50%", "50%"],
        },
        color: ["#FF9D3E", "#3D7EF8"],
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              show: false,
            },
          },
          right: "20px",
        },
        series: [
          {
            name: "价格",
            type: "pie",
            selectedMode: "single",
            radius: "100%",
            hoverAnimation: false,
            itemStyle: {
              normal: {
                borderWidth: 1, // 间距的宽度
                borderColor: "#fff", //背景色
              },
            },
            label: {
              normal: {
                position: "inner",
                show: true,
                formatter: "{b}",
              },
            },
            labelLine: {
              normal: {
                show: true,
              },
            },
            data: [
              {
                value: that.dogSummary.amount,
                name: "狗",
                label: {
                  color: "#fff",
                },
              },
              {
                value: that.catSummary.amount,
                name: "猫",
                label: {
                  color: "#fff",
                },
              },
            ],
          },
        ],
      });
    },
    //销售表
    draw0() {
      let that = this;
      // console.log(that.dogSummary,that.catSummary)
      this.myChart0.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
          position: ["50%", "50%"],
        },
        color: ["#FF9D3E", "#3D7EF8"],

        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              show: false,
            },
          },
          right: "20px",
        },
        series: [
          {
            name: "销售",
            type: "pie",
            selectedMode: "single",
            radius: "100%",
            hoverAnimation: false,
            itemStyle: {
              normal: {
                borderWidth: 1, // 间距的宽度
                borderColor: "#fff", //背景色
              },
            },
            label: {
              normal: {
                position: "inner",
                show: true,
                formatter: "{b}",
              },
            },
            labelLine: {
              normal: {
                show: true,
              },
            },
            data: [
              {
                value: that.dogSummary.count,
                name: "狗",
                label: {
                  color: "#fff",
                },
              },
              {
                value: that.catSummary.count,
                name: "猫",
                label: {
                  color: "#fff",
                },
              },
            ],
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.view {
  min-height: 852px;
  display: flex;
  margin-top: 6px;
  font-family: PingFangSC-Regular, PingFang SC;

  .viewLeft {
    // 左侧
    margin-left: 4px;
    margin-right: 12px;
    max-width: 251px;
    // 搜索
    .searchView {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
    }

    .search {
      width: 188px;
      background: #fff;
      box-shadow: 0px 1px 3px 0px rgba(102, 108, 254, 0.1);
      border-radius: 8px 4px 4px 8px;
      font-size: 12px;
      margin-right: 4px;
    }

    // 搜索信息
    .msg {
      height: 242px;
      background: #fff;
      box-shadow: 0px 2px 2px 0px rgba(140, 144, 254, 0.18);
      border-radius: 4px;
      padding: 12px;
      font-size: 12px;
      line-height: 17px;
      color: #666;

      .msgIcon {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        .msgName {
          width: 120px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        img:nth-of-type(1) {
          margin-right: 46px;
          margin-left: 7px;
        }

        img:nth-of-type(2) {
          margin-right: 12px;
        }

        img {
          width: 14px;
          height: 14px;
        }
      }

      .msgApply {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        div:nth-of-type(1) {
          width: 80px;
        }

        div:nth-of-type(2) {
          flex: 1;
        }
      }

      .msgCom {
        margin-bottom: 8px;
      }

      .msgBtn {
        color: #467eff;
        font-weight: bold;
      }
    }

    // 库存
    .stock {
      height: 167px;
      border-radius: 4px;
      background: url(../../assets/img/ht5.png) no-repeat;
      background-size: 100% 100%;
      color: #e1e1e1;
      margin-top: 12px;
      margin-bottom: 12px;
      padding-top: 12px;

      .stockName {
        font-size: 14px;
        line-height: 20px;
        margin-left: 18px;
        margin-bottom: 10px;
      }

      .line {
        width: 100%;
        height: 1px;
        background: rgba(255, 255, 255, 0.17);
        margin-bottom: 8px;
        margin-top: 8px;
      }

      .stockMsg {
        display: flex;
        align-items: center;

        .stockCom {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          div:nth-of-type(1) {
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 4px;
          }

          div:nth-of-type(2) {
            font-size: 12px;
            line-height: 17px;
          }
        }
      }
    }

    //销售表
    .rota {
      height: 302px;
      background: #fff;
      border-radius: 4px;
      padding: 0 12px;
      padding-top: 12px;
      font-size: 12px;

      .rotaName {
        line-height: 17px;
        margin-bottom: 8px;
        font-weight: bold;
      }

      .allNum {
        display: flex;
        align-items: center;
        line-height: 17px;
        margin-bottom: 8px;
        margin-top: 12px;

        div:nth-of-type(1) {
          margin-right: 16px;
          width: 40px;
        }
      }

      .comNum {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        div:nth-of-type(1) {
          width: 28px;
          height: 28px;
          text-align: center;
          color: #fff;
          margin-right: 28px;
          line-height: 28px;
          border-radius: 100%;
        }
      }

      .biao {
        display: flex;
        align-items: center;

        .biaoL {
          display: flex;
          flex-direction: column;
          align-items: center;
          // margin-right: 14px;
          flex: 1;
        }

        .biaoR {
          display: flex;
          flex-direction: column;
          align-items: center;
          flex: 1;
        }
      }
    }
  }

  .viewRight {
    // 右侧
    flex: 1;
    min-width: 1001px;
    margin-right: 4px;

    .tabView {
      display: flex;
      align-items: center;
      font-size: 12px;

      .tabCom {
        width: 15%;
        height: 60px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #fff;
        border-radius: 4px;
        margin-right: 12px;

        img {
          width: 30px;
          height: 30px;
          margin-bottom: 2px;
        }
      }
      .tabComS {
        width: 15%;
        height: 60px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #467eff;
        border-radius: 4px;
        margin-right: 12px;
        color: #fff;

        img {
          width: 30px;
          height: 30px;
          margin-bottom: 2px;
        }
      }
      .tabR {
        flex: 1;
        display: flex;
        align-items: center;
        background: #fff;
        .tabItem {
          flex: 1;
          height: 60px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          border-radius: 4px;

          .tabItemT {
            font-size: 14px;
            color: #467eff;
            font-weight: bold;
            // line-height: 20px;
            margin-bottom: 4px;
          }

          .tabIcon {
            display: flex;
            align-items: center;

            img {
              width: 10px;
              height: 10px;
              margin-left: 4px;
            }
          }
        }
        .tabItemS {
          flex: 1;
          height: 60px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          border-radius: 4px;
          color: #fff;
          background: #467eff;
          .tabItemT {
            font-size: 14px;
            font-weight: bold;
            margin-bottom: 4px;
          }

          .tabIcon {
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }
}
</style>
